export enum DomElementToggleState {
    ON = "on",
    OFF = "off"
}